import React from "react";
import { Routes, Route } from "react-router-dom";
import ReportePagosTipoBancoPage from "../pages/ReportePagosTipoBancoPage";
import ReportePagosDetalleCobrosPage from "../pages/ReportePagosDetalleCobrosPage";
import ReportePagosPorServicioPage from "../pages/ReportePagosPorServicioPage";
import ReportePagosDetalleTipoPage from "../pages/ReportePagosDetalleTipoPage";

const ReportePagosRoutes = () => {
  return (
    <Routes>
      <Route path="tipo-banco" element={<ReportePagosTipoBancoPage />} />
      <Route path="detalle-cobros" element={<ReportePagosDetalleCobrosPage />} />
      <Route path="por-servicio" element={<ReportePagosPorServicioPage />} />
      <Route path="detalle-tipo" element={<ReportePagosDetalleTipoPage />} />
    </Routes>
  );
};

export default ReportePagosRoutes;
